export const getMenuItems = () => {
  return [
    { key: "1", label: "Cotas" },
    { key: "7", label: "Copiar cotas" },
    { key: "8", label: "Acertar cotas" },
    { key: "9", label: "Copiar Apto" },
    { key: "2", label: "Editar Apartamento" },
    { key: "3", label: "Proprietario" },
    { key: "4", label: "Caracteristicas" },
    { key: "5", label: "Andamentos" },
    { key: "6", label: "Excluir" },
  ];
};
